import { BBDTag, GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'
import React from 'react'

export function TerminalHierarchyRenderer({ terminalNames, supplyZones, totalCount }) {
  // Used in conduction with a Terminal Supply Zone hierarchy selector to display the selected terminals and supply zones
  const terminalGroup = terminalNames.sort().map((terminal) => <Texto key={terminal}>{terminal}</Texto>)
  const supplyZonesGroup = supplyZones.sort().map((zone) => <Texto key={zone}>{zone}</Texto>)

  const content = (
    <div style={{ minHeight: '45px', maxHeight: '500px', minWidth: '300px', overflowY: 'scroll' }}>
      <Vertical style={{ gap: '1rem' }}>
        <Horizontal>
          <Vertical>
            <Texto weight='bold'>Supply Zones:</Texto>
            {supplyZonesGroup}
          </Vertical>
        </Horizontal>
        <Horizontal>
          <Vertical>
            <Texto weight='bold'>Terminals:</Texto>
            {terminalGroup}
          </Vertical>
        </Horizontal>
      </Vertical>
    </div>
  )

  if (totalCount === 0) {
    return
  }

  return (
    <Popover content={content} placement='bottomLeft'>
      <BBDTag style={{ fontWeight: 'bold' }}>{totalCount}</BBDTag>
    </Popover>
  )
}
